<div>
    <div style="margin-left: 70%; margin-bottom: 2%">
        <button *ngIf="updateStatus" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" (click)="saveSubscriptionBarcodesDataEntry()">
            save
        </button>

        <button *ngIf="!updateStatus" [disabled]="deleteDistrictwiseStatemet" class="noPrint" style="margin-right: 2%; margin-left: 2%;background-color: #f5365c;" mat-raised-button
            color="primary" (click)="deleteDistrictwiseStatementList()">
            delete
        </button>


        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printTitle="Pincodewise Statement" printSectionId="print-section" ngxPrint>
            print
        </button>
        <!-- <button mat-raised-button class="btn btn-info noPrint" (click)="print()"
            style="margin-right: 2%; margin-left: 2%">
            Print
        </button> -->
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div style="margin: 0px 15px;">
            <div class="row"
                style="text-align: center;border-width: 1px 1px 1px 1px; border-style: solid; border-color: black;padding-top: 05px; padding-bottom: 04px;">
                <span style=" font-size: 16px;font-weight: 600;margin: auto;">मा. विवेक, प्रभादेवी - २५ दि
                    {{sundayankDate}}
                    च्या
                    अंकाकरिता
                    पोस्ट स्टेटमेंट
                    वितरण दि {{dispatchankDate}}</span>
            </div>
            <div class="row">
                <div class="col noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;">
                    <label>
                        <input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()"> All
                    </label>
                </div>
                <div class="col" style="border-width: 0px 1px 1px 1px;">जिल्हा</div>
                <div class="col" style="border-width: 0px 1px 1px 0px;">वर्गणीदार संख्या</div>
                <div class="col" style="border-width: 0px 1px 1px 0px;">पार्सल संख्या</div>
            </div>
            <div class="row" *ngFor="let data of filtereddistrictwisesubcout; let i=index">
                <div class="col noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;">
                    <!-- <label>
                        <input type="checkbox" [(ngModel)]="item.isSelected" (change)="isAllSelected()"> {{ item.value }}
                      </label> -->
                    <input type="checkbox" [(ngModel)]="data.selected" (change)="isAllSelected()">
                </div>
                <div class="col" style="border-width: 0px 1px 1px 1px;">{{ data['district'] }}</div>
                <div class="col" style="border-width: 0px 1px 1px 0px;">{{ data['sub']
                    }}</div>
                    <!-- class="noPrint" -->
                <div class="col" style="border-width: 0px 1px 1px 0px;"><span >{{ data['parcel'] }}</span></div>
            </div>
            <div class="row">
                <div class="col noPrint" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;font-weight: 600;"></div>
                <div class="col" style="border-width: 0px 1px 1px 1px;font-weight: 600;">एकूण</div>
                <div class="col" style="border-width: 0px 1px 1px 0px;">{{ total_sub_count
                    }}</div>
                <div class="col" style="border-width: 0px 1px 1px 0px;">{{ totalparcel
                    }}={{ totalanksankhya
                    }}</div>
            </div>
        </div>
    </div>
</div>